<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
  show: boolean;
  message: string;
  type?: 'success' | 'info' | 'error';
}>();

const visible = ref(false);

watch(() => props.show, (newVal) => {
  visible.value = newVal;
});
</script>

<template>
  <Transition name="toast">
    <div
      v-if="visible"
      class="
        fixed
        top-24
        right-6
        z-50
        flex
        items-center
        gap-3
        px-4
        py-3
        bg-white
        dark:bg-gray-800
        border
        border-gray-200
        dark:border-gray-700
        rounded-lg
        shadow-lg
        max-w-sm
      "
      :class="{
        'border-l-4 border-l-green-500': type === 'success',
        'border-l-4 border-l-blue-500': type === 'info',
        'border-l-4 border-l-red-500': type === 'error'
      }"
    >
      <!-- Icône -->
      <div
        class="
          flex-shrink-0
          w-8
          h-8
          rounded-full
          flex
          items-center
          justify-center
        "
        :class="{
          'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400': type === 'success',
          'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400': type === 'info',
          'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400': type === 'error'
        }"
      >
        <fa
          v-if="type === 'success'"
          :icon="['fas', 'check']"
          class="text-sm"
        />
        <fa
          v-else-if="type === 'error'"
          :icon="['fas', 'times']"
          class="text-sm"
        />
        <fa
          v-else
          :icon="['fas', 'info']"
          class="text-sm"
        />
      </div>

      <!-- Message -->
      <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
        {{ message }}
      </p>
    </div>
  </Transition>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>

